import { Quill } from 'react-quill';

export const fonts = ['arial', 'georgia', 'impact', 'tahoma', 'times-new-roman', 'verdana', 'monospace'];

export const Fonts = () => {
  const Font = Quill.import('attributors/style/font');
  Font.whitelist = fonts;
  Quill.register(Font, true);
};
